import type { RadioProps } from '@mantine/core';
import { Radio as MantineRadio } from '@mantine/core';
import React from 'react';

import styles from './Radio.module.css';

export const LBRadio = React.forwardRef<
  React.ElementRef<typeof MantineRadio>,
  Omit<RadioProps, 'variant'>
>((props, ref) => (
  <MantineRadio {...props} ref={ref} classNames={styles} variant='outline' />
));
